import {useEffect, useState} from 'react'
import {useListView} from './core/ListViewProvider'
import { CardApplication } from '../../../_metronic/partials/content/cards/CardApplication'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL || 'api'

const ApplicationsList = () => {
  const {itemIdForUpdate} = useListView()
  const [applications, setApplications] = useState([])

  useEffect(() => {
    getApplications()
  }, [])

  const getApplications = async () => {
    const {data} = await axios.get(API_URL + '/v1/applications')
    console.log(data.data, 'data aqui')
    setApplications(data.data)
  }

  return (
    <>
      {/* <KTCard>
        <ApplicationsListHeader/>
      </KTCard> */}
      <div className='row mt-2'>
        {applications?.map((item: any)=>(
          <div className='col-4 my-2'>
            <CardApplication
              image={item.path}
              title={item.title}
              url={item.url}
            />
          </div>
        ))}
      </div>
      {/* <ApplicationsListPagination /> */}
      {itemIdForUpdate !== undefined}
      {/* {itemIdForUpdate !== undefined && <UserEditModal />} */}
    </>
  )
}

export {ApplicationsList}
